<template>
  <div class="ndata" >
    <el-header>
      <div class="ndata-head">
        <div class="header_left">
          <div class="header_logo">
            <img src="../assets/font-img.png">
          </div>
        </div>
        <div class="header_right">
          <span v-if="user" class="header_but" @click="signOut">退出</span>
          <span v-else class="header_but" @click="registerMessage">注册</span>

          <el-divider direction="vertical" class="divider"/>

          <span v-if="user" class="header_but">{{user.userName}}</span>
          <el-divider v-if="user" direction="vertical" class="divider"/>
          <span v-if="user" class="header_but" @click="handlePersonal">个人中心</span>
          <el-divider v-if="user" direction="vertical" class="divider"/>
          <span v-if="user" class="header_but" @click="handleEditPass">修改密码</span>
          <span v-else class="header_but" @click="signIn">登录</span>
        </div>
        <div class="search">
          <el-input type="text" v-model="form.title" placeholder="请输入您要搜索的内容"></el-input>
          <el-button type="primary" @click="homeSearch" class="search-button">搜索</el-button>
        </div>
      <ul class="header_nav">
        <li class="header_nav_item nav_opacity" :class="{
                header_nav_item_active: activeIndex === ''
              }" @click="toUrl(item)">首页</li>
        <li
          class="header_nav_item nav_opacity"
          v-for="(item,i) in columnTreeList"
          :key="i"
          :class="{
                header_nav_item_active: activeIndex === item.id
              }"
          @click="toUrl(item)"
        >
        <span>
          {{ item.columnName }}
        </span>

        </li>
      </ul>
      <el-divider class="home-hr"/>
      </div>
      <div class="main-core-content">
        <slot></slot>
      </div>
      <div>
        <Footer :top-height="20"></Footer>
      </div>
    </el-header>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import apis from '../apis/leader'
export default {
  data () {
    return {
      form: {
        title: ''
      },
      title: '',
      columnTree: [],
      dictList: []
    }
  },
  computed: {
    ...mapGetters(['columnTreeList', 'activeIndex', 'user'])
  },
  mounted () {
    console.log(this.activeIndex)
  },

  methods: {
    registerMessage () {
      this.$router.push({
        path: '/generalregister'
      })
    },
    signIn () {
      this.$router.push({
        path: '/login'
      })
    },
    signOut () {
      apis.logout().then(res => {
        const {code, msg} = res
        if (code === 0) {
          this.$store.commit('SET_USER')
          this.$cookie.delete('token')
          this.$router.push({
            path: '/'
          })
          this.$message.success(msg)
        } else {
          this.$message.warning(msg)
        }
      })
    },
    toUrl (item) {
      if (item) {
        console.log(item)
        this.$store.commit('SET_COLUMNITEM', item.children)
        this.$store.commit('SET_COLUMNITEM_PARENT', item)
        this.$store.commit('SET_ACTIVEINDEX', item.id)
        this.$router.push({
          path: '/' + item.columnCode,
          name: item.columnCode
        })
      } else {
        this.$store.commit('SET_COLUMNITEM', [])
        this.$store.commit('SET_COLUMNITEM_PARENT', [])
        this.$store.commit('SET_ACTIVEINDEX', '')
        this.$router.push({
          path: '/'
        })
      }
    },
    homeSearch () {
      console.log(this.form.title)
      localStorage.setItem('keywords', this.form.title)
      this.form.title = ''
      this.$store.commit('SET_ACTIVEINDEX')
      this.$router.push({
        path: '/sitesearch'
      })
    },
    handlePersonal () {
      this.$router.push({
        path: '/personalcenter'
      })
    },
    handleEditPass () {
      this.$router.push({
        path: '/editpass'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import url('../assets/css/bass.css');
  .header_nav{
    display: -webkit-box;
    display: -ms-flexbox;
    position: relative;
    font-size: 1.2rem;
    font-family: SourceHanSansCN-Regular-GBpc-EUC-H-, SourceHanSansCN-Regular-GBpc-EUC-H;
    font-weight: normal;
    color: #285ADC;
    line-height: 22px;
    /*left: 4rem;*/
    top:22px;
    width: 1000px
  }
  .header_nav_item{
    /*width: 72px;*/
    /*height: 24px;*/
    padding: 1rem 1.5rem;
    cursor: pointer;
  }
  .header_nav_item_active{
    color: #ffffff;
    border: solid 1px #285ADC ;
    background: #285ADC;
    background-size: 100% 100%;
    border-radius: 5px 5px 0px 0px;
  }
  .home-hr{
    margin-top: -2px;
    border: solid 2px #285ADC;
    background-color: #285ADC;
    opacity: 1;
    width: 99.7%;
  }
  .search-button{
    width: 55px;
    height: 40px;
    background: #285ADC;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    padding: 0px;
  }
  .demo-form-inline{
    display: -webkit-box;
    display: -ms-flexbox;
    position: relative;
    width: 274px;
    height: 90px;
    left: 75rem;
}
.el-form--inline .el-form-item{
  margin-right: 0px;
}
.el-input__inner{
  order-radius: 0px;
}
.header_left{
  width: 333px;
  height: 70px;
  padding: 22px 0px 0px 40px;
}
.header_logo{
  font-size: 30px;
  color: #163F8E;
  font-weight: 900;
  img{
    width: 310px;
  }
}
.header_logo_eg{
  font-size: 18px;
  color: #163F8E;
  font-weight: 600;
}
.main-core-content{
  width: 91%;
  /*min-height: 1000px;*/
  margin-left:5.3%;
}
.header_right{
  float: right;
  margin-right: 55px;
  margin-top: -30px;
  span{
    cursor: pointer;
  }
}
.header_but{
  font-size: 16px;
  font-family: SourceHanSansCN-Regular-GBpc-EUC-H-, SourceHanSansCN-Regular-GBpc-EUC-H;
  font-weight: normal;
  color: #285ADC;
  border: none;
  /*line-height: 10px;*/
}
/deep/.divider{
  background-color: #285ADC !important;
  margin-bottom: 2px;
  width: 2px;
}
.search{
  position: absolute;
  float: right;
  bottom: 0.5rem;
  right: 3rem;
  /*padding-top: 50px;*/
  /*padding-right: 167px;*/
  .el-input{
    width: 11rem;
  }
}
.ndata{
  width: 1250px;
  margin: 0 auto;
  /*min-height: 100vh;*/
}
.ndata-head{
  position: relative;
  /*background: linear-gradient(360deg, rgba(255,255,255,0) 0%, rgba(182,220,255,0.14) 19%, rgba(103,183,255,0.3) 43%, rgba(46,157,255,0.41) 66%, rgba(12,140,255,0.47) 85%, rgba(0,135,255,0.5) 99%);*/
  /*width: 103rem;*/
}
  /deep/ .el-header{
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu-layout.vue